import {
  getBrazilSectionMapping,
  resolveBrazilSectionMappingDetail,
  saveBrazilSectionMapping
} from '../../api/brazil';
import { resolveSectionMappingSaveResponse } from '../../api/sectionMapping';
import {
  buildSectionMappingPutBody,
  normalizePageMappingQcStatus,
  sectionMapToPageValues
} from '../Common/SectionMapping/sectionMappingLogic';
import {
  SectionMappingDetail,
  SectionMappingMode,
  SectionPageValues
} from '../Common/SectionMapping/types';
import useSectionMappingDialog, {
  SectionMappingDialogOptions
} from '../Common/SectionMapping/useSectionMappingDialog';

// Module-level adapters — stable references, safe as useEffect/useCallback deps.

const getBrazilInitialPages = (
  detail: SectionMappingDetail,
  mode: SectionMappingMode
): SectionPageValues =>
  sectionMapToPageValues(
    mode === 'section' ? detail.page_number_map_sections : detail.page_number_map
  );

const getBrazilQcStatus = (detail: SectionMappingDetail): string =>
  normalizePageMappingQcStatus(detail.qc_status);

const getBrazilPdfUrl = (detail: SectionMappingDetail, mode: SectionMappingMode): string | null =>
  (mode === 'section' ? detail.pdf_url : detail.original_pdf_url) ?? null;

const buildBrazilPayload = (
  mode: SectionMappingMode,
  pages: SectionPageValues,
  qcStatus: string,
  curatorName: string,
  curatorEmail: string,
  detail: SectionMappingDetail | null
) => buildSectionMappingPutBody(mode, pages, qcStatus, curatorName, curatorEmail, detail?.s3_path);

type BrazilSectionMappingDialogOptions = Omit<
  SectionMappingDialogOptions<SectionMappingDetail, SectionMappingMode>,
  | 'fetchDetail'
  | 'resolveDetail'
  | 'saveDetail'
  | 'resolveSave'
  | 'getInitialPages'
  | 'getQcStatus'
  | 'getPdfUrl'
  | 'buildPayload'
>;

const useBrazilSectionMappingDialog = (options: BrazilSectionMappingDialogOptions) =>
  useSectionMappingDialog<SectionMappingDetail, SectionMappingMode>({
    ...options,
    fetchDetail: getBrazilSectionMapping,
    resolveDetail: resolveBrazilSectionMappingDetail,
    saveDetail: saveBrazilSectionMapping,
    resolveSave: resolveSectionMappingSaveResponse,
    getInitialPages: getBrazilInitialPages,
    getQcStatus: getBrazilQcStatus,
    getPdfUrl: getBrazilPdfUrl,
    buildPayload: buildBrazilPayload
  });

export default useBrazilSectionMappingDialog;
